export const config = {
    nextRacesCount: 3,
    nextLinesCount: 3
}